import { Component, OnInit } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { DecorType } from '../../models/decor-type';
import { DecorTypeService } from '../../services/decor-type.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-decor-type',
  templateUrl: './decor-type.component.html',
  styleUrls: ['./decor-type.component.css']
})
export class DecorTypeComponent extends EditForm<DecorType> implements OnInit {

  constructor(
    ns: ToastrService,   
    tr: TranslateService,       
    r: Router,
    ds:DecorTypeService,
    ar: ActivatedRoute,
    l:Location,        
  ) { 
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/decor-type');    
  }
  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
    });
    super.ngOnInit();    
  }
}
